import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import ReleaseNotesRepository from '@/services/repository/ReleaseNotesRepository';
var releaseNotesRepository;
let WPReleaseNote = class WPReleaseNote extends Vue {
    constructor() {
        super(...arguments);
        this.postDetail = null;
        this.detailOpened = false;
    }
    created() {
        releaseNotesRepository = new ReleaseNotesRepository(this);
        if (this.showInline) {
            this.loadPost();
        }
    }
    async loadPost() {
        if (!this.postDetail)
            this.postDetail = await releaseNotesRepository.getReleaseNoteDetail(this.postPreview.id);
        this.detailOpened = true;
    }
    closeCollapse() {
        this.detailOpened = false;
    }
};
__decorate([
    Prop({ type: Object })
], WPReleaseNote.prototype, "postPreview", void 0);
__decorate([
    Prop({ type: Boolean })
], WPReleaseNote.prototype, "showInline", void 0);
WPReleaseNote = __decorate([
    Component({ components: {} })
], WPReleaseNote);
export default WPReleaseNote;
